import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" id=\"refresh\"><path fill-rule=\"evenodd\" d=\"M12.709 2.291A7.703 7.703 0 0 0 7.739.479C3.472.479 0 3.95 0 8.219c0 4.267 3.473 7.738 7.74 7.738 2.13 0 4.062-.865 5.463-2.262l-.902-.902a6.442 6.442 0 0 1-4.56 1.888 6.47 6.47 0 0 1-6.463-6.463 6.47 6.47 0 0 1 6.462-6.463c1.539 0 2.953.542 4.064 1.442L9.574 5.426H15V0l-2.291 2.291z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol